import { CurrentStatus } from 'features/patient/_components/symptom-card/components/current-status';
import { BRAINFUNCTION_COLOR_SCHEME } from 'features/patient/_components/symptom-card/symptom-card-2';
import { PatientInfoState } from 'features/patient/_utils/patient-info/patient-info-slice-types';
import { ConcussionComplexityDiagramWrapper } from 'features/patient/patient-summary/components/concussion-complexity-diagram';
import {
  brainFunctionVisualisations,
  prepareBrainFunctionVisualisation
} from 'lib/utils/business/brainfunction-categories';
import { imageStoreKeyFactory } from '../utils/imageStoreKeyFactory';

interface SerialiseComponentProps {
  registerImage: (key: string, image: string) => void;
}

export function SerialiseBrainFunctionVisualisations(
  params: {
    patientInfo: PatientInfoState;
  } & SerialiseComponentProps
) {
  // This is not memoised because it will only run once in the render pipeline
  const groupedCategories = brainFunctionVisualisations.map(_ => ({
    ..._,
    __refName__: imageStoreKeyFactory.brainfunctionVisualisation(_)
  }));

  return (
    <>
      {groupedCategories.map(c => {
        const data = prepareBrainFunctionVisualisation(c, params.patientInfo);

        return (
          <CurrentStatus
            id={c.__refName__}
            key={c.__refName__}
            colors={BRAINFUNCTION_COLOR_SCHEME}
            scale={data.brainFunction.scale}
            sortedData={data.data}
            showLabels={false}
            showValue={false}
          />
        );
      })}
    </>
  );
}

export const SERIALISE_CONCUSSION_COMPLEXITY_SCALE_CLASSNAME =
  'report-concussion-complexity-diagram';
export function SerialiseConcussionComplexityScale(
  props: {
    patientInfo: PatientInfoState;
  } & SerialiseComponentProps
) {
  return (
    <div id={SERIALISE_CONCUSSION_COMPLEXITY_SCALE_CLASSNAME}>
      <ConcussionComplexityDiagramWrapper
        concussion={props.patientInfo.concussion}
      />
    </div>
  );
}
